import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/app/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/(website)/appalti/HighlightsAppalti.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/(website)/appalti/MainBannerAppalti.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/(website)/appalti/PotentialMarketAppalti.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/(website)/appalti/SamplesAppalti.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/(website)/appalti/SourcesAppalti.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/(website)/appalti/WhyAppalti.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/(website)/components/ContactUs.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/(website)/components/Header.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/AIcon.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/images/Logo.svg");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/IubendaLink.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Accordion","AccordionItem","AccordionTrigger","AccordionContent"] */ "/app/src/components/ui/accordion.tsx");
